// src/components/common/Logo.jsx
// Logo displayed as a 3D glossy bubble button - only the image, no extra text
import React from "react";
import logoImg from "../../assets/logo_transparent.00f0da9599043373c489.png";

const sizes = {
  sm: 44,
  md: 64,
  lg: 88,
  xl: 112,
};

const Logo = ({ size = "md", className = "" }) => {
  const dim = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {/* 3D Bubble Button wrapper */}
      <div
        style={{
          width:  dim + 24,
          height: dim + 24,
          borderRadius: "50%",
          background:
            "radial-gradient(circle at 35% 30%, #ffffff 0%, #f0f6ff 55%, #dceeff 100%)",
          boxShadow: [
            "0 8px 28px rgba(26,125,232,0.28)",          // outer blue glow
            "0 2px 6px rgba(255,255,255,0.90) inset",    // top-left inner highlight
            "0 -3px 10px rgba(26,125,232,0.18) inset",   // bottom inner depth
            "0 1px 0 rgba(255,255,255,1) inset",         // rim highlight
          ].join(", "),
          border: "1.5px solid rgba(255,255,255,0.95)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          position: "relative",
          // 3D pressed feel on click
          cursor: "default",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
        }}
        className="animate-float"
      >
        {/* Glass shine overlay */}
        <div
          style={{
            position: "absolute",
            top: "8%",
            left: "12%",
            width: "55%",
            height: "42%",
            borderRadius: "50%",
            background:
              "radial-gradient(ellipse at 40% 30%, rgba(255,255,255,0.80) 0%, rgba(255,255,255,0.10) 100%)",
            pointerEvents: "none",
          }}
        />
        <img
          src={logoImg}
          alt="QuBright Technologies LLP"
          width={dim}
          height={dim}
          style={{ objectFit: "contain", display: "block", position: "relative", zIndex: 1 }}
        />
      </div>
    </div>
  );
};

export default Logo;
